<template>
  <!-- 2026-09-17：默认保持正式原文流，显式清单按宽度省略或换行；提示与复制始终使用原值。 -->
  <span :class="['list-text', kind === 'order' ? 'list-order-number' : 'list-product-name', {'list-text-responsive':responsiveEnabled,'list-text-wrap':responsiveEnabled && wrap && kind!=='order'}]" :title="fullText">
    <span class="list-text-value">{{ displayText }}</span>
    <button v-if="kind === 'order' && fullText" type="button" class="copy-order-button" title="复制完整订单号" aria-label="复制完整订单号" @click.stop="copyNumber">
      <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true"><rect x="5" y="5" width="9" height="9" rx="1" stroke="currentColor"/><path d="M10 3V2H2v8h1" stroke="currentColor"/></svg>
    </button>
  </span>
</template>
<script lang="ts">
import { computed, defineComponent, inject, Ref, ref } from 'vue'
import { message } from 'ant-design-vue'
import { copyFullOrderNumber } from '@/utils/compactList'
export default defineComponent({
  name: 'ListText',
  props: { value: { type: [String, Number], default: '' }, kind: { type: String, default: 'product' }, wrap:{type:Boolean,default:false},responsive:{type:Boolean,default:undefined} },
  setup(props) {
    // 2026-09-17：四清单继承明确的响应模式，其他页面保持原文字流；全文提示与复制不受影响。
    const tableResponsive=inject<Ref<boolean>>('landiyun-responsive-table',ref(false))
    const responsiveEnabled=computed(()=>props.responsive ?? tableResponsive.value)
    const fullText = computed(() => String(props.value ?? ''))
    const displayText=computed(()=>fullText.value)
    const copyNumber = async () => {
      try { await copyFullOrderNumber(fullText.value); message.success('订单号已复制') }
      catch (error) { message.error(error instanceof Error ? error.message : '复制失败，请手动复制订单号') }
    }
    return { fullText, displayText, copyNumber, responsiveEnabled }
  }
})
</script>
<style scoped>
.list-text { vertical-align:middle; }
.list-text-responsive { display:inline-flex; align-items:center; min-width:0; max-width:100%; gap:4px; }
.list-text-responsive .list-text-value { min-width:0; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.list-order-number.list-text-responsive { width:100%; }
/* 2026-09-17：名称保留原文，由当前列空间决定展示长度；可选两行展示仍保留全文提示。 */
.list-product-name.list-text-responsive{width:100%;}
.list-text-wrap .list-text-value{white-space:normal;overflow-wrap:anywhere;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;}
.copy-order-button { flex:none; display:inline-flex; align-items:center; padding:3px; border:0; background:transparent; color:var(--activeColor,#1890ff); cursor:pointer; line-height:1; }
.copy-order-button:focus-visible { outline:2px solid var(--activeColor,#1890ff); outline-offset:1px; }
</style>
